module.exports = __webpack_public_path__ + "static/oec.35248c3b.png";